<template>
	<anchor-element :chain="chain" class="menu-item submenu-item" :class="{ 'submenu-item-open': visible }" @click="menuClick" @mouseenter="entered" @mouseleave="left">
		<sym-icon v-if="hasIcon" :name="menu.icon" class="menu-fi"></sym-icon>
		<span v-else class="fi menu-fi"> </span>
		<span class="mi mi-label" :style="extraStyles">{{ menu.title }}</span>
		<sym-icon name="caret-right-12" class="menu-item-caret"></sym-icon>
	</anchor-element>
	<boat-element :tag="MenuPanel" :chain="chain" :menu="menu" :vertical-correction="true"></boat-element>
</template>

<script setup lang="ts">
import SymIcon from "@fd/helpers/SymIcon.vue";
import {type MenuItemWithChildren} from "@t/ui/Menu";
import {computed} from "vue";
import MenuPanel from "@fd/editors/menu/MenuPanel.vue";
import AnchorElement from "@/ui/paneltree/AnchorElement.vue";
import BoatElement from "@/ui/paneltree/BoatElement.vue";
import {createChain} from "@/ui/paneltree/PanelTree";
import {ElementMeasure} from "@fd/helpers/DomUtils";

/**
 * This is functionally identical to MenuPart editor from fd/ codebase but without dependence
 * to FD infrastructure.
 **/
const props = defineProps<{
	menu: MenuItemWithChildren
}>();

const AUTO_OPEN_MS = 500;

const chain = createChain({
	rule: (m:ElementMeasure) => {
		if (m.spaceRight < 200 && m.spaceLeft > m.spaceRight) return {
            ah: 0, av: 50,
            bh: 100, bv: 40,
            x: -2, y: 0
        };
		return {
            ah: 100, av: 50,
            bh: 0, bv: 40,
            x: 2, y: 0
        };
	}
}, "first");
const { toggle, show, hide, visible } = chain;

const hasTitle = computed(() => !!props.menu.title);
const hasIcon = computed(() => !!props.menu.icon);

const extraStyles = computed<string|null>(() => {
	if (props.menu.style) return props.menu.style;
	return null;
});

let hesitate:number;

function cancelHesitate() {
	if (hesitate) {
		clearTimeout(hesitate);
		hesitate = 0;
	}
}

function menuClick(e:MouseEvent) {
	cancelHesitate();
	show();
}


function entered(e:MouseEvent) {
	cancelHesitate();
	hesitate = setInterval(() => {
		if (!visible.value) {
			show();
		}
	}, AUTO_OPEN_MS);
}

function left(e:MouseEvent) {
	cancelHesitate();
}

</script>

<style>
.menu-item-caret {
	margin-left: 8px;
}
.submenu-item {
	cursor: pointer;
	background-color: var(--link-bg);
	color: var(--link-fg);
}
.submenu-item:hover,
.submenu-item.submenu-item-open {
	background-color: var(--bg);
	color: var(--link-fg-hover);
}
</style>
